import { SwitchButton } from '@components/core-ui/form-elements/buttons/Button/variations/SwitchButton';
import { HeaderSwitchWrapper } from '@components/Header/components/HeaderSwitchWrapper';
import { routes } from '@routes';
import { useNavigate } from 'react-router';

type TProps = {
  currentTab: string;
};

export const Tabs = ({ currentTab }: TProps) => {
  const navigate = useNavigate();
  return (
    <HeaderSwitchWrapper key="tabSwitcher">
      <SwitchButton active={currentTab === 'Users'} onClick={() => navigate(routes.adminAttorneyUsers.make())}>
        Users
      </SwitchButton>
      <SwitchButton active={currentTab === 'Invitations'} onClick={() => navigate(routes.adminAttorneysAccess.make())}>
        Invitations
      </SwitchButton>
      <SwitchButton active={currentTab === 'Passcodes'} onClick={() => navigate(routes.adminAttorneysPasscodes.make())}>
        Passcodes
      </SwitchButton>
    </HeaderSwitchWrapper>
  );
};
